var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"block"},attrs:{"id":"app"}},[_c('navigation'),_c('hr',{staticStyle:{"margin":"0","color":"rgb(0, 0, 0)"}}),_c('a-back-top',{on:{"click":_vm.click}}),_c('keep-alive',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }